// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToListModalStyles } from "@bg/Overrides/Components/AddToListModal";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

addToListModalStyles.manageListsLink = {
    css: css`
        flex-grow: 1;
        justify-content: flex-start;
        margin: 0 !important;
        @media (max-width: 481px) {
            justify-content: center;
        }
    `,
    icon: {
        iconProps: {
            src: "ArrowRight",
            size: 15,
            color: "tertiary",
        },
        position: "right",
    },
};

addToListModalStyles.groupsWrapper = {
    css: css`
        ${addToListModalStyles.groupsWrapper?.css}
        align-items: flex-start;
    `,
};

addToListModalStyles.groupItem = {
    css: css`
        ${addToListModalStyles.groupItem?.css}
        &&& .item-wrapper span {
            color: ${getColor("text.main")};
            font-size: ${fontConfig.fontSize.small}px;
            line-height: 17px;
            letter-spacing: 1px;
            font-weight: ${fontConfig.weight.semiBold};
        }
    `,
};

addToListModalStyles.addNewButton = {
    variant: "secondary",
    css: css`
        ${addToListModalStyles.addNewButton?.css}
        &&& svg polygon {
            fill: ${getColor("text.main")};
        }
    `,
};

addToListModalStyles.addNewGroupItem = {
    css: css`
        ${addToListModalStyles.addNewGroupItem?.css}
        &&& + span {
            color: ${getColor("text.main")} !important;
            font-size: ${fontConfig.fontSize.small}px;
            line-height: 17px;
            letter-spacing: 1px;
            font-weight: ${fontConfig.weight.semiBold};
        }
    `,
};
